/* istanbul ignore file */
// TODO add tests for PaymentSetup
import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import {
  useStripe,
  useElements,
  PaymentElement,
  Elements,
} from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js/pure'
import configment from '@adc/configment'
import { Button, Loader } from '@adc/ui-core'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const CheckoutForm = ({ confirmPayment }) => {
  const stripe = useStripe()
  const elements = useElements()

  const [message, setMessage] = useState(null)
  const [isProcessing, setIsProcessing] = useState(false)

  const handleSubmit = async e => {
    e.preventDefault()
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return
    }

    setIsProcessing(true)

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/`,
      },
      redirect: 'if_required',
    })

    if (
      error &&
      (error.type === 'card_error' || error.type === 'validation_error')
    ) {
      setMessage(error.message)
    } else if (error) {
      setMessage('An unexpected error occured. ', error.message)
    } else if (!error) {
      confirmPayment()
    }

    setIsProcessing(false)
  }

  return (
    <form id='payment-form' onSubmit={handleSubmit}>
      <PaymentElement id='payment-element' />
      <Button
        className={cx('payment-submit-button')}
        disabled={isProcessing || !stripe || !elements}
        id='submit'
      >
        {isProcessing ? 'Processing ... ' : 'Pay Now'}
      </Button>
      {/* Show any error or success messages */}
      {message && <div id='payment-message'>{message}</div>}
    </form>
  )
}

CheckoutForm.propTypes = {
  confirmPayment: PropTypes.func.isRequired,
}

const PaymentSetup = ({ clientSecret, isLoading, message, confirmPayment }) => {
  const stripePublishableKey = configment.get('STRIPE_PUBLISHABLE_KEY')
  const stripePromise = useMemo(
    () => loadStripe(stripePublishableKey),
    [stripePublishableKey]
  )

  return (
    <>
      {isLoading ? (
        <Loader elmId='stripe_spinner' active={isLoading} inverted />
      ) : (
        <>
          {clientSecret && stripePromise && (
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <CheckoutForm confirmPayment={confirmPayment} />
            </Elements>
          )}
          {message && <div>{message}</div>}
        </>
      )}
    </>
  )
}

PaymentSetup.propTypes = {
  clientSecret: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  message: PropTypes.bool,
  confirmPayment: PropTypes.func,
}

export default PaymentSetup
